export const ROUTES = {
  students: "/dashboard/students",
  teachers: "/dashboard/teachers",
  routes: "/dashboard/bus-routes",
  classes: "/dashboard/class-management",
  alerts: "/dashboard/alert",
  settings: "/dashboard/settings",
  teacherAttendance: "/dashboard/teacher-attendance",
};

export const THEME = {
  primary: "#0263cc",
  primaryDark: "#024ea3",
  success: "#10b981",
  warning: "#f59e0b",
  danger: "#ef4444",
  secondary: "#ff6b35",
};

export const TEXT = {
  loading: "Loading dashboard...",
  errorGeneric: "Something went wrong",
  tabs: {
    overview: "overview",
  },
  quickActions: {
    students: "Students",
    teachers: "Teachers",
    routes: "Routes",
    classes: "Classes",
    alerts: "Alerts",
    settings: "Settings",
  },
  statsCards: {
    totalStudents: { title: "Total Students", description: "Annual enrollment", badge: "Active" },
    activeRoutes: { title: "Active Routes", description: "Operating routes", badge: "routes" },
    attendance: { title: "Attendance", description: "Daily average" },
    performance: { title: "Performance", description: "Average score" },
    teachers: { title: "Teachers", description: "Active staff", badge: "active" },
    pendingTasks: { title: "Pending Tasks", description: "Requires attention", badge: "tasks" },
  },
  charts: {
    monthlyTrends: { title: "Monthly Trends", description: "Attendance & Performance" },
    recentActivity: { title: "Recent Activity", description: "Latest updates and notifications" },
    feeManagement: { title: "Fee Management Overview", description: "Monthly fee trends: Created, Pending, and Paid fees" },
    enrollmentTrends: {
      title: "Enrollment Trend Analysis",
      description: "Comprehensive view of enrollment metrics across academic years",
    },
    vehicleRoutes: {
      title: "Students per Vehicle Route",
      description: "Distribution of students across vehicle routes",
      xLabel: "Number of Students",
      tooltipRoutePrefix: "Route:",
    },
  },
  emptyStates: {
    noMonthlyData: "No monthly data available",
    noRecentActivity: "No recent activity",
    noFeeData: "No fee data available",
    noRouteDataTitle: "No route data available",
    noRouteDataHint: "Add vehicles to see student distribution",
  },
};

// Backend should send `icon` as a stable key (e.g. "bus", "bell").
// We also support older values like "Bus" / "Bell".
export const ACTIVITY_ICON_KEY_ALIASES = {
  bus: "bus",
  Bus: "bus",
  bell: "bell",
  Bell: "bell",
  users: "users",
  Users: "users",
  clock: "clock",
  Clock: "clock",
  award: "award",
  Award: "award",
  activity: "activity",
  Activity: "activity",
  settings: "settings",
  Settings: "settings",
};

